import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
//import search from './store/search';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

Vue.use(Router)

// Routes
const paths = [
  {
    path: '/',
    name: 'Search',
    view: 'Search'
  },
  {
    path: '/search',
    name: 'Search',
    view: 'Search'
  },
  {
    path: '/datasets',
    name: 'Datasets',
    view: 'Search'
  },
  {
    path: '/datasets/:id',
    name: 'Dataset',
    view: 'Dataset'
  },
  {
    path: '/pdfs',
    name: 'PDFs',
    view: 'Search'
  },
  {
    path: '/pdfs/:id',
    name: 'PDF',
    view: 'PDF'
  },
  {
    path: '/news',
    name: 'News',
    view: 'Search'
  },
  /*{
    path: '/topics',
    name: 'Topics',
    view: 'Search'
  },
  {
    path: '/locations',
    name: 'Locations',
    view: 'Search'
  },
  {
    path: '/trades',
    name: 'Trades',
    view: 'Search'
  },
  {
    path: '/scales',
    name: 'Scales',
    view: 'Search'
  },
  {
    path: '/providers',
    name: 'Providers',
    view: 'Search'
  },*/
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'login'
    }
  },
  {
    path: '/login/forgot',
    name: 'Forgot password',
    view: 'Login',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'request'
    }
  },
  {
    path: '/login/forgot/:token',
    name: 'Change password',
    view: 'Login',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'reset'
    }
  },
  {
    path: '/register',
    name: 'Register',
    view: 'Register',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'a'
    }
  },
  {
    path: '/register/verify',
    name: 'Verify account',
    view: 'Register',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'c'
    }
  },
  {
    path: '/register/verify/:hash',
    name: 'Verify account',
    view: 'Register',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'c'
    }
  },
  {
    path: '/register/thanks',
    name: 'Thank you',
    view: 'Register',
    meta: {
      requiresGuest: true,
      group: 'auth',
      step: 'd'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/details',
    name: 'User details',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/personalization',
    name: 'Personalization',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/licenses',
    name: 'Licenses',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/notifications',
    name: 'Notifications',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/bookmarks',
    name: 'Bookmarks',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '/settings/logs',
    name: 'Activity log',
    view: 'Settings',
    meta: {
      requiresAuth: true,
      group: 'auth'
    }
  },
  {
    path: '*',
    name: '404',
    view: '404'
  }
]

// Initializing router
const router = new Router({
  mode: process.env.VUE_APP_URL === 'http://statzon.local:8090/' ? 'hash' : 'history',
  routes: paths.map(path => route(path.name, path.view, path.path, path.meta)).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    let customBehavior = 'auto'

    if (to.query.page !== from.query.page) {
      customBehavior = 'smooth'
    }

    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 82 }, behavior: customBehavior }
    }
    return { x: 0, y: 0, behavior: customBehavior }
  }
})

// Restricted views and before route changing
router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token') === null && (to.name === 'Search' || to.name === 'Dataset' || to.name === 'PDF')) {
    store.dispatch('search/setIncomingUrl', to.fullPath)
  }

  if (localStorage.getItem('token') !== null && to.name === 'Register' && to.query.mode && to.query.mode === 'ai') {
    window.location = 'https://ai.statzon.com'
  }

  if (process.env.VUE_APP_URL === 'https://app.statzon.com/') {
    gtag('config', window.GA_TRACKING_ID, {
      page_path: to.fullPath,
      app_name: 'Statzon',
      send_page_view: true,
      custom_map: {
        logged_in: 'logged_in',
        subscription_status: 'subscription_status'
      }
    })
  }

  if (to.meta.requiresAuth) {
    if (store.getters['user/isAuthenticated']) {
      next()
    } else {
      next('/')
    }
  } else if (to.meta.requiresGuest) {
    if (store.getters['user/isAuthenticated']) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

// Helper function to automatically import view components
function route (name, view, path, meta) {
  return {
    name: name,
    view: view,
    path: path,
    meta: meta,
    component: (resolve) => import(
      `@/views/${view}.vue`
    ).then(resolve)
  }
}

export default router
